import { Fragment } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

export default function UserLayout(){
    let isAdmin=useSelector(state=>state.user.isAdmin)

    if(isAdmin){
        return <Navigate to='/401'/>
    }

    return <Fragment>
        <Outlet/>
    </Fragment>
}